"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specialties = [{
  name: "JUNIOR ACADEMY",
  origin: "DEVELOPMENT",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/birkalla_juniors_action.png",
  description: "Nurturing the next generation of talent through our MiniRoos, SAP, and JPL pathways with elite coaching."
}, {
  name: "SENIOR FOOTBALL",
  origin: "ELITE",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/birkalla_seniors_match.png",
  description: "The pinnacle of our club's performance, featuring our First Team, Reserves, and U18s competing at the highest level."
}, {
  name: "BUSINESS NETWORK",
  origin: "COMMUNITY",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/birkalla_business_network.png",
  description: "Connecting local enterprises and sponsors through a powerful directory and collaborative growth opportunities."
}];
export default function KitchenSpecialties() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224121" id="our-core-pillars" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`mb-20 text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 tracking-tighter uppercase">
            Our Core Pillars
          </h2>
          <p className="font-default text-muted-foreground max-w-2xl mx-auto text-lg leading-relaxed">
            Built on a foundation of excellence since 1933, WT Birkalla is dedicated to player development, elite performance, and a thriving business community.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {specialties.map((dish, i) => <div key={i} data-index={i} className={`group relative overflow-hidden transition-all duration-1000 ease-out border-t-2 border-transparent hover:border-primary rounded-lg ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <AspectRatio ratio={3 / 4} className="bg-card">
                <img src={dish.image} alt={dish.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 mix-blend-luminosity group-hover:mix-blend-normal" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-background via-background/20 to-transparent transition-opacity duration-500" />

                {}
                <div className="absolute top-5 right-5 z-20">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-primary bg-background/80 backdrop-blur-md px-2.5 py-1 border border-primary/30">
                    {dish.origin}
                  </span>
                </div>

                {}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-20">
                  <Badge variant="outline" className="bg-primary text-primary-foreground border-none py-2 px-6 text-xs tracking-widest uppercase font-default rounded-none">
                    Explore Program
                  </Badge>
                </div>

                {}
                <div className="absolute bottom-0 left-0 right-0 p-8 z-20 transform transition-transform duration-500 group-hover:-translate-y-2">
                  <h3 className="font-default text-3xl md:text-4xl text-foreground mb-4 leading-tight font-extrabold uppercase tracking-tighter">
                    {dish.name}
                  </h3>
                  <p className="font-default text-sm text-muted-foreground leading-relaxed max-w-[95%]">
                    {dish.description}
                  </p>
                </div>
              </AspectRatio>
            </div>)}
        </div>
      </div>
    </section>;
}